import Papa from "papaparse/papaparse.min.js";

const parseTabDelimited = (source) =>
  new Promise((resolve, reject) => {
    Papa.parse(source, {
      header: false,
      skipEmptyLines: true,
      delimiter: "\t",
      complete: (results) => resolve(results),
      error: (error) => reject(error),
    });
  });

export const parseWindows1252TabFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const decoder = new TextDecoder("windows-1252");
        const text = decoder.decode(event.target.result);
        const results = await parseTabDelimited(text);
        resolve(results);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);

    reader.readAsArrayBuffer(file);
  });

export const parseTabFile = async (file) => parseTabDelimited(file);
